export default "__VITE_ASSET__DPbyXtda__"